import {imageUpload} from './helpers';
import tinymce from 'tinymce';
import 'tinymce/icons/default';
import 'tinymce/models/dom';
import 'tinymce/plugins/code';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';
import 'tinymce/plugins/image';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/autosave';
import 'tinymce/plugins/quickbars';
import 'tinymce/themes/silver';
import './tinymce/ru.js';
import axios from 'axios';


export function registerEditor(document: Document) {

    axios({
        url: '/app/manifest.json',
        method: 'get',
    }).then(response => {
        const css_files = [
            'https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Open+Sans:wght@300&family=Pacifico&family=Poppins&family=Raleway&display=swap',
            '/'+response.data['public/style.css'],
        ];
        tinymce.remove();
        // noinspection JSVoidFunctionReturnValueUsed
        tinymce.init({
            selector: '[data-ckeditor]',
            language: 'ru',
            menubar: false,
            skin: false,
            min_height: 285,
            max_height: 1000,
            plugins: 'code link lists table image autoresize wordcount autosave quickbars',
            toolbar: 'formatselect bold italic underline strikethrough | forecolor backcolor blockquote | alignleft aligncenter alignright alignjustify | numlist bullist checklist | hr image link table | code | restoredraft wordcount',
            quickbars_selection_toolbar: 'formatselect bold italic underline strikethrough | forecolor backcolor blockquote | alignleft aligncenter alignright alignjustify | numlist bullist checklist | link',
            quickbars_insert_toolbar: 'formatselect bold italic underline strikethrough | forecolor backcolor blockquote | alignleft aligncenter alignright alignjustify | numlist bullist checklist | hr image link table',
            quickbars_image_toolbar: 'alignleft aligncenter alignright | image link',
            content_css: css_files,
            browser_spellcheck: true,
            file_picker_types: 'image',
            relative_urls: false,
            image_description: false,
            typeahead_urls: false,
            setup: (editor) => {
                editor.on('keydown', function (e) {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        if (e.shiftKey) {
                            tinymce.activeEditor.execCommand('mceInsertNewLine');
                        } else {
                            tinymce.activeEditor.execCommand('InsertLineBreak');
                        }
                    }
                });
                editor.on('change', (e) => {
                    if (!e.target.isDirty()) {
                        return;
                    }
                    const htmlDoc = new DOMParser().parseFromString(e.target.getContent(), 'text/html');
                    htmlDoc.querySelectorAll('img').forEach(imgElement => {
                        if (new URL(imgElement.src).host === window.location.host) {
                            return;
                        }
                        const _image = new Image();
                        _image.crossOrigin = 'anonymous';
                        _image.onload = () => {
                            const canvas = document.createElement('canvas');
                            canvas.width = _image.width;
                            canvas.height = _image.height;
                            const ctx = canvas.getContext("2d");
                            ctx.drawImage(_image, 0, 0);
                            canvas.toBlob((file: string | Blob) => {
                                imageUpload(file, result => {
                                    imgElement.src = '/storage/images/' + result.data.file;
                                    e.target.setContent(htmlDoc.body.innerHTML);
                                });
                            });
                        };
                        _image.src = imgElement.src;
                    });

                });
            },
            file_picker_callback: cb => {
                const input = document.createElement('input');
                input.setAttribute('type', 'file');
                input.setAttribute('accept', 'image/*');
                input.onchange = e => {
                    const file = (<HTMLInputElement>e.target).files[0];
                    imageUpload(file, result => {
                        cb('/storage/images/' + result.data.file, {title: file.name});
                    });
                };
                input.click();
            },
        }).then(editors => {
            editors.forEach(editor => {
                editor.on('change', () => {
                    editor.editorManager.triggerSave();
                });
            })
        });
    }).catch(error => {
        console.log(error);
    });


}